// Client → Brand → Campaign filters (Creatividades, Front Desk): each one narrows the next, and the options are
// exactly what the API lists for the caller (its scope included). Empty value = all.
import { NativeSelect } from "@/ui/input";
import { useBrands, useCampaigns, useClients } from "./queries";

export interface HierarchyValue {
  readonly clientId: string;
  readonly brandId: string;
  readonly campaignId: string;
}

export function HierarchyFilters({
  orgId,
  value,
  onChange,
}: {
  orgId: string;
  value: HierarchyValue;
  onChange: (patch: HierarchyValue) => void;
}) {
  const clients = useClients(orgId);
  const brands = useBrands(orgId, value.clientId || undefined);
  const campaigns = useCampaigns(orgId, value.brandId || undefined);
  return (
    <>
      <NativeSelect
        aria-label="Cliente"
        value={value.clientId}
        onChange={(e) => {
          onChange({ clientId: e.target.value, brandId: "", campaignId: "" });
        }}
      >
        <option value="">Todos los clientes</option>
        {clients.items.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </NativeSelect>
      <NativeSelect
        aria-label="Marca"
        value={value.brandId}
        disabled={!value.clientId}
        onChange={(e) => {
          onChange({ clientId: value.clientId, brandId: e.target.value, campaignId: "" });
        }}
      >
        <option value="">Todas las marcas</option>
        {brands.items.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
      </NativeSelect>
      <NativeSelect
        aria-label="Campaña"
        value={value.campaignId}
        disabled={!value.brandId}
        onChange={(e) => {
          onChange({ clientId: value.clientId, brandId: value.brandId, campaignId: e.target.value });
        }}
      >
        <option value="">Todas las campañas</option>
        {campaigns.items.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </NativeSelect>
    </>
  );
}
